import { Injectable } from '@angular/core';
import { UserTab, ReviewType, Team } from '../models/user-access.model';

@Injectable({ providedIn: 'root' })
export class UserRoleService {
  rollName = '';
  email = '';
  enterpriseId = '';
  teams: Team[] = [];
  tabs: UserTab[] = [];
  reviewTypes: ReviewType[] = [];

  get isSupervisor(): boolean {
    return this.rollName?.toLowerCase() === 'supervisor';
  }

  get isManager(): boolean {
    return this.rollName?.toLowerCase() === 'manager';
  }

  get isReviewer(): boolean {
    return this.rollName?.toLowerCase() === 'reviewer';
  }

  get isAdmin(): boolean {
    return this.rollName?.toLowerCase() === 'administrator';
  }

  get isRCMember(): boolean {
    return this.rollName?.toLowerCase() === 'r&c member';
  }

  getTabAccess(tabKey: string): 'READ_ONLY' | 'READ_WRITE' | null {
    return this.tabs.find(t => t.TabKey === tabKey)?.AccessLevel ?? null;
  }
}
